import {FACTIONS} from "../../../constants/factions";

export const ELEMENTALS_QUOTES = [{
  quote: 'Земля ждала миллион лет, чтобы стать стеной. Я ждать не буду',
  author: 'Литоген, элементаль-архитектор Семисводчатых городов',
  factionId: FACTIONS.ELEMENTALS
}, {
  quote: 'Мы не строим. Мы приказываем камням лечь, а огню — застыть в форме стены',
  author: 'Аргос, элементаль-эспиратор Семисводчатых городов',
  factionId: FACTIONS.ELEMENTALS
}, {
  quote: 'Время — ресурс. Элементали не берут плату временем. Они берут плату усталостью человека, который за ними не успевает',
  author: 'Нирон Сантийский, исследователь истории рас нечеловеческих',
  factionId: FACTIONS.ELEMENTALS
}]